import { render, staticRenderFns } from "./consignorAddAccount.vue?vue&type=template&id=6bc56152&scoped=true&"
import script from "./consignorAddAccount.vue?vue&type=script&lang=js&"
export * from "./consignorAddAccount.vue?vue&type=script&lang=js&"
import style0 from "./consignorAddAccount.vue?vue&type=style&index=0&id=6bc56152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc56152",
  null
  
)

export default component.exports